import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Receivable } from "../model/domain/Receivable";
import { ReceivableStatus } from "../model/domain/ReceivableStatus";
import { ReceivableFund } from "../model/domain/ReceivableFund";
import {
  ReceivableMonitor,
  ReceivableMonitorFilter,
} from "../model/domain/ReceivableMonitor";
import { Bank } from "../model/domain/Bank";
import { PagedList } from "../model/domain/PagedList";

@Injectable({
  providedIn: "root",
})
export class ReceivablesService {
  constructor(private http: HttpClient) {}

  SendFiles() {
    return this.http.get(
      `${environment.apiUrls.receivable}/process-send-file/1`,
      {}
    );
  }

  ReceiveFiles() {
    return this.http.get(
      `${environment.apiUrls.receivable}/process-return-file/1`,
      {}
    );
  }

  GetFiles(
    startDate: Date = null,
    endDate: Date = null,
    statusId: number = null,
    fileName: string = null,
    fundId: number = null,
    page: number = null,
    pageSize: number = null
  ) {
    const params: any = {};

    if (startDate) {
      params.startDate = startDate.toJSON();
    }

    if (endDate) {
      params.endDate = endDate.toJSON();
    }

    if (statusId) {
      params.statusId = statusId.toString();
    }

    if (fileName) {
      params.fileName = fileName;
    }

    if (fundId) {
      params.fundId = fundId.toString();
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    return this.http.get<PagedList<Receivable>>(
      `${environment.apiUrls.receivable}/files`,
      {
        params,
      }
    );
  }

  GetServerTimestamp() {
    return this.http.get<string>(
      `${environment.apiUrls.receivable}/server-info/server-timestamp`
    );
  }

  GetStatuses() {
    return this.http.get<ReceivableStatus[]>(
      `${environment.apiUrls.receivable}/statuses`
    );
  }

  GetFunds() {
    return this.http.get<ReceivableFund[]>(
      `${environment.apiUrls.receivable}/funds`
    );
  }

  GetReceivableMonitors(
    startDate: Date = null,
    endDate: Date = null,
    statusId: number = null,
    fileName: string = null,
    fundDocument: string = null,
    bankCode: string = null,
    page: number = null,
    pageSize: number = null
  ) {
    const params: any = {};

    if (startDate) {
      params.startDate = startDate.toJSON();
    }

    if (endDate) {
      params.endDate = endDate.toJSON();
    }

    if (statusId) {
      params.codeStatus = statusId.toString();
    }

    if (fileName) {
      params.fileName = fileName;
    }

    if (fundDocument) {
      params.fundDocument = fundDocument;
    }

    if (bankCode) {
      params.bankCode = bankCode;
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    return this.http.post<PagedList<ReceivableMonitor>>(
      `${environment.apiUrls.receivable}/receivable-monitors/`,
      params
    );
  }

  GetBanks() {
    return this.http.get<Bank[]>(`${environment.apiUrls.receivable}/banks`);
  }
}
